module.exports = __webpack_public_path__ + "img/loss.d0dbfdb.png";